import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { animate, style, group, useAnimation, keyframes, animation, query, stagger } from "@angular/animations";

declare var window: any;

@Component({
  selector: 'app-solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.scss']
})
export class SolutionsComponent implements OnInit {

  route;

  public display: boolean;
  public show: boolean;
  public showPhone: boolean;
  public showPhone2: boolean;
  public showPhone3: boolean;
  public showPhone4: boolean;
  public video1: boolean;
  public video2: boolean;
  public video3: boolean;
  public video4: boolean;
  public videoTwo: boolean;
  public parallax1: boolean;
  public parallax2: boolean;
  public parallax3: boolean;
  public parallax4: boolean;
  public parallax5: boolean;
  public parallax6: boolean;
  public parallax7: boolean;
  public parallax8: boolean;
  public parallax9: boolean;
  public parallax10: boolean;
  public parallax11: boolean;

  public parallax12: boolean;
  public parallax13: boolean;
  public parallax14: boolean;
  public parallax15: boolean;
  public parallax16: boolean;
  public parallax17: boolean;
  public parallax18: boolean;
  public parallax19: boolean;
  public parallax20: boolean;

  public fixed1: boolean;

  public text1: boolean;
  public text2: boolean;

  public itsMobile = false;

  public urlVideo1 = "https://player.vimeo.com/progressive_redirect/playback/708795944/rendition/540p/file.mp4?loc=external&signature=ac5d7b26ee44f9c1df21b025524c570540dc79d4eb9da0a77bfc17ea9d81a1aa";
  public urlVideo2 = "https://player.vimeo.com/progressive_redirect/playback/708795944/rendition/540p/file.mp4?loc=external&signature=ac5d7b26ee44f9c1df21b025524c570540dc79d4eb9da0a77bfc17ea9d81a1aa";
  public urlVideo3 = "https://player.vimeo.com/progressive_redirect/playback/708795944/rendition/540p/file.mp4?loc=external&signature=ac5d7b26ee44f9c1df21b025524c570540dc79d4eb9da0a77bfc17ea9d81a1aa";
  public urlVideo4 = "https://player.vimeo.com/progressive_redirect/playback/708795944/rendition/540p/file.mp4?loc=external&signature=ac5d7b26ee44f9c1df21b025524c570540dc79d4eb9da0a77bfc17ea9d81a1aa";

  SlideOptions = {
    items: 1,
    dots: true,
    nav: false,
    margin: 60,
    autoplay: true,
    loop: true
  };

  grow = animation(
    [
      style({height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px'}),
      animate('200ms', style({ height: '*', paddingTop: '*', paddingBottom: '*', marginTop: '*', marginBottom: '*' })),
    ],
  );

  animate =  [
    query('img', [ 
      stagger(500, [
        animate('2000ms', style({ transform: 'translateX(550px) rotate3d(-3, 4, 1, 35deg)' }))
      ])
    ])
  ];

  animate2 =  [
    query('img', [ 
      stagger(500, [
        animate('2000ms', style({ transform: 'translateX(-500px) translateY(200px)', opacity: '1'}))
      ])
    ])
  ];

  constructor(private el: ElementRef) {
    this.route = window.location.hash;
  }

  loadVideoForPosition() {
    let sectionRoot = window.document;
    let options = {
      root: sectionRoot
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(elem => {
        if (elem.isIntersecting) {
          let id = elem.target?.id;
          this.pauseAllVideos(id);
        }
      });
    }, options);
    document.querySelectorAll('video').forEach(elem => observer.observe(elem));
  }


  callback = (entries) => {
    entries.forEach((entry) => {
      const el = entry.target;
      let previousY = 0
      let previousRatio = 0
      const nav = this.el.nativeElement.querySelector('.nav');
      if (entry.isIntersecting) {
        if (entry.target.className == 'target0') {
          this.parallax1 = false;
          console.log('Target 1')
        } else if (entry.target.className == 'target1') {
          nav.style.opacity = '1';
          this.parallax1 = true;
          this.parallax2 = false;
          this.video2 = true;
          console.log('Target 2')
        } else if (entry.target.className == 'target2') {
          nav.style.opacity = '1';
          this.parallax2 = true;
          this.parallax3 = false;
          this.video3 = true;
        } else if (entry.target.className == 'target3') {
          nav.style.opacity = '1';
          this.parallax3 = true;
          this.parallax4 = false;
          this.video4 = true;
        }
      }
      const currentY = entry.boundingClientRect.y
      const currentRatio = entry.intersectionRatio
      const isIntersecting = entry.isIntersecting

      previousY = currentY
      previousRatio = currentRatio

    });

    document.querySelectorAll(".btn-v").forEach(element => {
      element.id.split("btn-")[1]
      element.addEventListener("click", () => {
        document.querySelector("#item-" + element.id.split("btn-")[1]).scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      })
    })
  };

  ngOnInit(): void {
    const el0 = this.el.nativeElement.querySelector('.target0');
    const el1 = this.el.nativeElement.querySelector('.target1');
    const el2 = this.el.nativeElement.querySelector('.target2');
    const el3 = this.el.nativeElement.querySelector('.target3');
    const el4 = this.el.nativeElement.querySelector('.target4');
    const el5 = this.el.nativeElement.querySelector('.target5');
    const el6 = this.el.nativeElement.querySelector('.target6');
    const el7 = this.el.nativeElement.querySelector('.target7');
    const el8 = this.el.nativeElement.querySelector('.target8');
    const el9 = this.el.nativeElement.querySelector('.target9');
    const el10 = this.el.nativeElement.querySelector('.target10');
    const el11 = this.el.nativeElement.querySelector('.target11');
    const el12 = this.el.nativeElement.querySelector('.target12');
    const el13 = this.el.nativeElement.querySelector('.target13');
    const el14 = this.el.nativeElement.querySelector('.target14');
    const el15 = this.el.nativeElement.querySelector('.target15');
    const el16 = this.el.nativeElement.querySelector('.target16');
    const el17 = this.el.nativeElement.querySelector('.target17');
    const el18 = this.el.nativeElement.querySelector('.target18');
    const el19 = this.el.nativeElement.querySelector('.target19');

    const IO = new IntersectionObserver(this.callback, {
      root: null, // default, use viewport
      threshold: 1 // half of item height
    });
    IO.observe(el0);
    IO.observe(el1);
    IO.observe(el2);
    IO.observe(el3);
    IO.observe(el4);
    IO.observe(el5);
    IO.observe(el6);
    IO.observe(el7);
    IO.observe(el8);
    IO.observe(el9);
    IO.observe(el10);
    IO.observe(el11);
    IO.observe(el12);
    IO.observe(el13);
    IO.observe(el14);
    IO.observe(el15);
    IO.observe(el16);
    IO.observe(el17);
    IO.observe(el18);
    IO.observe(el19);
    setTimeout(() => {
      this.loadVideoForPosition();
    }, 250);
  }


  /* @HostListener('body:scroll', ['$event'])
  onScrollingEvent($event): void {
     let scrollOffset = $event.target.scrollTop;
     const image = this.el.nativeElement.querySelector('.main-image');
     image.style.top = scrollOffset + 'px';

  } */

  Navigate(elem: HTMLElement) {
    elem.scrollIntoView({ behavior: 'smooth' });
  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  pauseAllVideos(id) {
    document.querySelectorAll('video').forEach((elem: any) => {
      if (elem) {
        try {
          if (!(elem.id == id)) {
            if (elem.paused) {
              // elem.currentTime = 0;
              elem.loop = true;
              elem.load();
              elem.pause();
            }
          }
        } catch (error) {
        }
      }
    });
    this.playVideoForId(id);
  }

  playVideoForId(id) {
    let video: any = document.getElementById(id);
    if (video) {
      try {
        if (video.paused) {
          return video.play();
        }
      } catch (error) {
      }
    }
  }

}
